import { z } from 'zod'
import { checkPassword } from '@/contexts/shared/users/Users.services'
import { t } from '@/I18n'
import { notEmptyString } from '@/contexts/shared/form-validation/FormValidationRules.helpers'

export const passwordSchema = (token: string) =>
  notEmptyString.max(128).superRefine(async (value, ctx) => {
    const result = await checkPassword(value, token)
    if (!result.ok) {
      const message =
        typeof result.error.message === 'string' && result.error.message ? result.error.message : t('zod.errors.custom')
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
      })
    }
  })

export const passwordConfirmSchema = () => notEmptyString

export const passwordResetFormSchema = () =>
  z
    .object({
      password: z.string(),
      password_confirm: z.string(),
    })
    .superRefine((data, ctx) => {
      if (data.password && data.password_confirm && data.password !== data.password_confirm) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('zod.errors.password_match'),
          path: ['password_confirm'],
        })
      }
    })
